import React, { ReactNode } from "react";

interface ButtonCodeHeadingProps {
    number: number;
    children: ReactNode;
    description?: string;
}

export const ButtonCodeHeading = ({ number, children, description }: ButtonCodeHeadingProps) => {
    return (
        <div>
            <div className="flex w-64 flex-col space-y-1 font-bold">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border text-md">
                    {number}
                </div>
                <div className="text-lg leading-p1">{children}</div>
            </div>
            {description && (
                <div className="ml-16 w-60">
                    <span className="text-gray-darker">{description}</span>
                </div>
            )}
        </div>
    );
};
